<template>

  <article class="user_view">
    <left-menu/>
    <section class="user_view__header">
      <div @click="$router.push({ name: 'Guards' })" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>
      <div class="user_view__header--info">
        <div>
          <h2>Guardas sin reporte </h2>
          <h4>Listado de guardas sin reporte</h4>
        </div>
      </div>
        <div class="user_view__header--sec1">  
            <info-table :name="'guardas sin reporte'"
             :columns="columns"
             :items.sync="splopes"
              :actions="false"
              @checked="checkedSlope"
            />                
            
            <div class="info_table__foot">
              <div/>
              <div class="paginator">
                {{shownItemsFrom}} - {{shownItemsTo}} 
                <div class="paginator__numbers">
                  <div v-for="(page,i) in total_pages" @click="handlePageChange(i+1)" :key=i class="paginator__numbers--num" :class="{'active': currentPage==i+1}">
                    {{i+1}}
                  </div>
                  <div class="paginator__numbers--num" @click="handlePageChange(currentPage+1)">
                    >
                  </div>
                </div>
              </div>
            </div>

        </div>     
    </section>

  </article>
</template>
<script>
import Table from './../shared/Table';
export default {
  components:{
    "info-table":Table,
  },
  data(){
    return{
      columns:[
        {
          name: '',
          sortable: false,
        },
        {
          name: 'Fecha',
          sortable: false,
        },
        {
          name: 'Hora',
          sortable: false,
        },
        {
          name: 'Nombre',
          sortable: false,
        },        
        {
          name: 'Cedula',
          sortable: false,
        },        
        {
          name: 'Teléfono',
          sortable: false,
        },  
        {
          name: 'Estado actual',
          sortable: false,
        },          
      ],
      splopes:[],
      total_pages: 0,
      currentPage: 1,
      shownItemsFrom:0,
      shownItemsTo: 12,
      maxPage:12,
    }
  },
  methods:{

    handlePageChange(value) {
      this.currentPage = value;
      this.getReports()
    },

    processData(value){
      
    },
    checkedSlope(newSlopes){
      // this.splopes=newSlopes;
      this.getReports();
      console.log(newSlopes);
    },
    getReports(){
      const customActions={
        get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
      };
      var card=JSON.parse(localStorage.getItem("user")).id_card; 
      this.$resource('administrators/reports/' + '?page=' + this.currentPage ,{},customActions).get({"id_card":card,"turn":{}})
      .then(function(data){
        this.total_pages = data.body.total_pages
        console.log('reportes //*/*', data)
        // this.splopes=data.body;
        this.splopes=data.body.data;    
      });
    }
  },
  created(){    
    this.getReports();

  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Notice.vue